export default __webpack_public_path__ + "static/media/body-olive.99b09321.png";